export enum APPOINTMENT_DETAILS_STORAGE_KEYS {
  KeyLabelPrintSizePreference = "appointment-details-key-label-print-size"
}
